import EmployeeRatesTable from "./EmployeeRatesTable";

export default EmployeeRatesTable;